var _g, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThanxAiSparkles(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 40,
    viewBox: "0 0 46 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_810_1739)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.9525 9.50434L24.3545 12.6308C23.9672 12.8219 23.5406 12.8219 23.2055 12.6308L17.5476 9.5L19.8369 15.5923C19.9761 15.9483 19.9152 16.3782 19.6758 16.7386L15.6587 22.9134L22.248 19.7435C22.6354 19.5525 23.0619 19.5525 23.397 19.7435L29.0593 22.9221L26.7961 16.743C26.6568 16.3869 26.7178 15.957 26.9572 15.5966L30.9525 9.50434Z",
    fill: "#13C1BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7655 27.3159L37.8388 29.6521C37.5515 29.7954 37.2295 29.7954 36.9814 29.6521L32.7553 27.3159L34.4658 31.8667C34.5702 32.1359 34.5224 32.4529 34.3439 32.7221L31.3452 37.3336L36.2633 34.9671C36.5505 34.8238 36.8726 34.8238 37.1207 34.9671L41.3511 37.338L39.6624 32.7264C39.5579 32.4572 39.6015 32.1402 39.7843 31.871L42.7655 27.3159Z",
    fill: "#13C1BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.63616 7.41624L1.41013 5.08008L3.12056 9.63082C3.22501 9.90004 3.18149 10.217 2.9987 10.4863L0 15.0978L4.91804 12.7312C5.20529 12.5879 5.52736 12.5879 5.77544 12.7312L10.0058 15.1021L8.31715 10.4906C8.2127 10.2214 8.25622 9.90439 8.43901 9.63516L11.4203 5.08008L6.49356 7.41624C6.20631 7.55954 5.88424 7.55954 5.63616 7.41624Z",
    fill: "#13C1BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7574 2.68789L45.5157 0L42.6084 1.37651C42.4386 1.45902 42.2515 1.45902 42.1035 1.37651L39.6096 0L40.6194 2.68355C40.6803 2.83987 40.6542 3.03093 40.5497 3.18726L38.7827 5.90989L41.6857 4.51166C41.8554 4.42916 42.0469 4.42916 42.1906 4.51166L44.6844 5.90989L43.6877 3.18726C43.6225 3.03528 43.6486 2.84421 43.7574 2.68789Z",
    fill: "#13C1BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3545 34.0913L16.4472 35.4678C16.2774 35.5503 16.0859 35.5503 15.9423 35.4678L13.4485 34.0869L14.4582 36.7705C14.5191 36.9268 14.493 37.1178 14.3886 37.2742L12.6172 40.0011L15.5202 38.6029C15.6899 38.5204 15.8814 38.5204 16.025 38.6029L18.5189 40.0011L17.5222 37.2785C17.4613 37.1222 17.4874 36.9311 17.5918 36.7748L19.3545 34.0913Z",
    fill: "#13C1BF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_810_1739"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 40,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThanxAiSparkles);
export default __webpack_public_path__ + "static/media/thanx-ai-sparkles.38ec55a6cc11a939ce7e875350c19928.svg";
export { ForwardRef as ReactComponent };